
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

import Vue from 'vue'

var DetailMsgCom = Vue.extend({})

Vue.component('detail-msg', DetailMsgCom)

export default {
name: 'DetailMsg',
props: {
auditData: Array
},
components: {
Flow,
FlowState,
FlowLine,
Timeline,
TimelineItem
},
data () {
return {
baseUrl: this.$store.state.url
}
},
mounted () {
},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/components/detail/Msg.vue